import React from 'react';
import { Camera, Video, Heart, Film } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { services } from '../data/mock';

const iconMap = {
  'Foto Prewedding': Camera,
  'Video Prewedding': Video,
  'Foto Wedding': Heart,
  'Video Wedding': Film
};

const ServicesSection = () => {
  return (
    <section id="layanan" className="py-20 lg:py-32 bg-gradient-to-b from-white to-[#C1CCBC]/20">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-fraunces font-bold text-[#00382F] mb-4">
            Layanan Kami
          </h2>
          <p className="text-lg text-[#658C8D] font-lato max-w-2xl mx-auto">
            Kami menyediakan berbagai layanan dokumentasi profesional untuk
            mengabadikan momen spesial Anda
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-10 max-w-5xl mx-auto">
          {services.map((service, index) => {
            const Icon = iconMap[service.title];
            return (
              <Card
                key={service.id}
                className="group hover:shadow-2xl transition-all duration-500 border-none bg-white hover:bg-gradient-to-br hover:from-[#658C8D]/5 hover:to-[#C1CCBC]/10 transform hover:-translate-y-2 animate-in fade-in slide-in-from-bottom-4 duration-700"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <CardContent className="p-8 lg:p-10">
                  <div className="flex flex-col items-center text-center">
                    <div className="w-16 h-16 lg:w-20 lg:h-20 rounded-full bg-[#658C8D] flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300 shadow-lg">
                      <Icon className="text-white" size={32} />
                    </div>
                    <h3 className="text-2xl font-fraunces font-bold text-[#00382F] mb-4">
                      {service.title}
                    </h3>
                    <p className="text-[#658C8D] font-lato leading-relaxed">
                      {service.description}
                    </p>
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;